import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './CustomAttributesReportView';

export default withErrorWrapper(view);
